import dataExample from './getById.json'

export default JSON.stringify({
  ...dataExample,
})
